import { render, staticRenderFns } from "./SlsD.vue?vue&type=template&id=2c60cadd"
import script from "./SlsD.vue?vue&type=script&lang=js"
export * from "./SlsD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports